const { ccclass, property, menu } = cc._decorator;

@ccclass
@menu("自定义组件/ChangeImgUtil")
export default class ChangeImgUtil extends cc.Component {
    @property([cc.SpriteFrame])
    sfs: cc.SpriteFrame[] = [];
    @property({ displayName: "是否循环" })
    loop: boolean = false;
    private spriteComponent: cc.Sprite = null
    get sprite() {
        if (this.spriteComponent == null) this.sprite = this.node.getComponent(cc.Sprite);
        return this.spriteComponent
    }
    set sprite(sp: cc.Sprite) {
        this.spriteComponent = sp
    }
    nowIdx: number = 0;
    tiem: number = 0;
    tiem2: number = 0;
    time: number = 0;
    changeImgById(idx: number) {
        if (!this.sprite) {
            this.sprite = this.node.getComponent(cc.Sprite);
        }
        if (!this.sprite) {
            cc.warn("current node can not find cc.Sprite!");
        } else {
            if (this.sfs[idx] == null) {
                console.warn("没有对应的图片，图片id:", idx)
            }
            this.sprite.spriteFrame = this.sfs[idx];
            this.nowIdx = idx;
        }
    }

    next() {
        this.nowIdx++;
        if (this.nowIdx > this.sfs.length - 1) {
            if (this.loop) {
                this.nowIdx = 0;
            } else {
                cc.warn("it's last one")
            }
        } else {
        }
        this.changeImgById(this.nowIdx);
    }

    last() {
        this.nowIdx--;
        if (this.nowIdx < 0) {
            if (this.loop) {
                this.nowIdx = this.sfs.length - 1;
            } else {
                cc.warn("it's first one")
            }
        } else {
        }
        this.changeImgById(this.nowIdx);
    }
    /**
     * 播放
     * @param sum 单位帧 
     * @param time 暂停时间
     * */
    onPlay(sum: number, time: number) {
        this.onStop();
        this.tiem = 0;
        this.tiem2 = sum
        this.time = time;
        this.schedule(this.onTime, sum * 0.033)
    }
    onTime() {
        this.tiem = this.tiem + this.tiem2 * 0.033
        if (this.nowIdx >= this.sfs.length) {
            this.nowIdx = 0;
        }
        if (this.tiem >= this.time) {
            this.tiem = 0;
            this.nowIdx = 0;
            this.next();
        } else {
            this.next();
        }
    }
    /**暂停播放 */
    onStop() {
        this.unschedule(this.onTime);
    }



    moveSche: () => void = null;
    /**
     * 循环播放动画 
     * @param loop 是否循环
     * @param imgIndex 循环图片ID
     * @param time 间隔时间
     * @param call 不循环时 播放最后一个回调
     * @param loopCall 每次切换时的回调
     * @returns 
     */
    loopPlayerImg(loop: boolean, imgIndex?: number[], time: number = 0.5, call?: () => void, loopCall?: (index: number) => void,loopTimes:number = -1) {
        if (this.moveSche) this.unschedule(this.moveSche)
        this.moveSche = null;
        if (imgIndex && imgIndex.length == 0) {
            console.warn("循环播放动画，没有配置参数")
            return
        }
        let index = 0;
        let times:number = 0
        this.moveSche = () => {
            if (index >= imgIndex.length) {
                if (loop) {
                    times++;
                    index = 0;
                    if(loopTimes>0){
                        if(times>=loopTimes){
                            this.unschedule(this.moveSche)
                            call && call();
                            return
                        }
                    }
                } else {
                    this.unschedule(this.moveSche)
                    call && call();
                    return
                }
            }

            loopCall && loopCall(index);
            this.changeImgById(imgIndex[index])
            index++;
        }

        if (this.moveSche) {
            this.moveSche()
            this.unschedule(this.moveSche)
            if (imgIndex.length > 1) this.schedule(this.moveSche, time)
            else {
                call && call();
            }
        }
    }

   
    stopLoop(nowid?:number) {
        if (this.moveSche) {
            this.unschedule(this.moveSche)
            this.moveSche();
            if(nowid!=null)this.changeImgById(nowid)
        }
    }
}
